import React, { useState } from "react";
import useFetchApi from "hooks/useFetchApi";
import Main from "components/Main";
import Checkbox from "components/Checkbox";
import Button from "components/Button";
import { ReactComponent as LoadingIcon } from "images/icons/loading.svg";

export default function BulkMessaging() {
  const [fetchApi] = useFetchApi();
  const [referencesStr, setReferences] = useState("");
  const [toCustomer, setToCustomer] = useState(true);
  const [toPartner, setToPartner] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [result, setResult] = useState();

  const normalizedMessage = message.trim();

  const referenceIds = referencesStr
    .replace(/[^0-9]+/g, " ")
    .split(" ")
    .filter(Boolean);

  const sendMessage = async () => {
    setError(null);
    setResult(null);
    setLoading(true);

    try {
      setResult(
        await fetchApi("message/create-bulk", {
          body: {
            dossierIds: referenceIds.join(","),
            message,
            toCustomer,
            toPartner,
          },
        }),
      );
    } catch (e) {
      setError(e.message);
    }

    setLoading(false);
  };

  return (
    <Main title="Message groupé adressé à plusieurs dossiers">
      <div className="mt-2">
        <label className="text-main-color text-xs md:text-sm">
          Références des dossiers
          <textarea
            placeholder="CEE-666 CEE-1337 CEE-007"
            value={referencesStr}
            rows="5"
            className="w-[100%] my-2 p-2 text-xs border-0.5 border-[#001F3B] rounded-md"
            onChange={(event) => setReferences(event.target.value)}
          ></textarea>
        </label>
      </div>

      <div className="my-2 text-main-color text-xs md:text-sm">
        <span className="mr-2">Envoyer au</span>
        <label>
          <Checkbox checked={toCustomer} onChange={setToCustomer} />
          <span className="mx-2">Bénéficiaire</span>
        </label>
        <label>
          <Checkbox checked={toPartner} onChange={setToPartner} />
          <span className="mx-2">Partenaire</span>
        </label>
      </div>

      <div className="mt-2">
        <label className="text-main-color text-xs md:text-sm">
          Message
          <textarea
            placeholder="Tapez votre message"
            value={message}
            rows="10"
            className="w-[100%] my-2 p-2 text-xs border-0.5 border-[#001F3B] rounded-md"
            onChange={(event) => setMessage(event.target.value)}
          ></textarea>
        </label>
      </div>

      <div className="mt-2">
        <Button
          label="Envoyer le message"
          icon={loading ? <LoadingIcon /> : null}
          disabled={
            loading ||
            referenceIds.length === 0 ||
            normalizedMessage.length === 0 ||
            (!toCustomer && !toPartner)
          }
          onClick={sendMessage}
        />
      </div>

      {error && (
        <p className="mt-4 font-semibold text-md text-red-500">{error}</p>
      )}

      {result && (
        <ul className="mt-4 font-semibold text-md ">
          <li>
            <span className="w-[80px] inline-block">Envoyés&nbsp;</span>:{" "}
            {result.filter(({ success }) => success).length}
          </li>
          <li>
            <span className="w-[80px] inline-block">Échecs&nbsp;</span>:{" "}
            {result.filter(({ success }) => !success).length}
          </li>
          {result.map(({ dossierId, channel, success, error }) => (
            <li
              key={`${dossierId}-${channel}`}
              className={success ? "text-green" : "text-red-500"}
            >
              <span className="w-[215px] inline-block">
                CEE-{dossierId}&nbsp;(
                {channel === "client" ? "Bénéficiaire" : "Partenaire"})
              </span>{" "}
              :&nbsp;{success ? "OK" : <>Erreur&nbsp;: {error}</>}
            </li>
          ))}
        </ul>
      )}
    </Main>
  );
}

BulkMessaging.propTypes = {};
